export default function FpsMonitor() {
  let beginTime = ( performance || Date ).now();
  let prevTime = beginTime;
  let frames = 0;
  let enabled = false;

  return {
    enable: () => {
      beginTime = ( performance || Date ).now();
      prevTime = beginTime;
      enabled = true;
    },
    
    disable: () => {
      enabled = false;      
    },

    begin: () => {
      if (!enabled) {
        return false;
      }

      beginTime = ( performance || Date ).now();
    },

    end: () => {
      if (!enabled) {
        return false;
      }

      frames++;

      const time = ( performance || Date ).now();

      if (time >= prevTime + 1000) {
        const fps = Math.round((frames * 1000) / (time - prevTime));

        prevTime = time;
        frames = 0;

        return fps;
      } else {
        return false;
      }
    }
  }
}